import axios from 'axios';
import { showToast } from './toastService';
import baseUrl from 'Base_Url/baseUrl';

const axiosInstance = axios.create({
  baseURL: baseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

let unauthorizedErrorHandled = false;
let errorDebounceTimer = null;

const resetErrorState = () => {
  unauthorizedErrorHandled = false;
};

const handleUnauthorizedError = () => {
  if (unauthorizedErrorHandled) return;

  unauthorizedErrorHandled = true;

  if (errorDebounceTimer) {
    clearTimeout(errorDebounceTimer);
  }

  errorDebounceTimer = setTimeout(() => {
    showToast('🔒 Your session has expired. Please login again.');

    localStorage.clear();
    localStorage.removeItem('token');
    localStorage.removeItem('user');

    setTimeout(() => {
      window.location.href = '/auth/sign-in';
      resetErrorState();
    }, 2000);
  }, 100);
};

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      const { status } = error.response;

      if (status === 401) {
        handleUnauthorizedError();
      }

      if (status === 403 && !unauthorizedErrorHandled) {
        showToast('❌ You are not allowed to access this page!');
      }
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
